import { makeStyles } from "@mui/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";

const useStyles = makeStyles({
  paper: {
    marginTop: "20px",
    paddingBottom: "20px",
  },
  title: {
    paddingTop: "20px;",
    paddingBottom: "20px;",
  },
  rowNotSelected: {
    cursor: "pointer",
  },
  rowSelected: {
    cursor: "pointer",
    backgroundColor: "#b5e7a4",
  },
  cursorLink: {
    cursor: "pointer",
  },
  loading: {
    marginRight: "10px",
    marginLeft: "10px",
  },
});

export default function ConceitoAlunoCargaHorariaTable({ listCACH }) {
  const classes = useStyles();

  return (
    <div style={{ backgroundColor: "#9cd3d3", padding: 5 }}>
      <Grid container className={classes.title} justifyContent="space-between">
        <Grid size={5}>
          <Typography variant="h5">Conceito Aluno</Typography>
        </Grid>
      </Grid>

      <Table size="small" aria-label="a dense table">
        <TableHead>
          <TableRow>
            <TableCell>Cód. Disciplina</TableCell>
            <TableCell>Descrição Disciplina</TableCell>
            <TableCell>Nº Bimestre</TableCell>
            <TableCell>Conceito</TableCell>
            <TableCell>Carga Horária</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {listCACH
            ? listCACH.map((caCh) => (
                <TableRow key={caCh.conceitoAluno.codigo}>
                  <TableCell>
                    {caCh?.conceitoAluno?.tdp?.disciplina?.codDisciplina}
                  </TableCell>
                  <TableCell>
                    {caCh?.conceitoAluno?.tdp?.disciplina?.descricao}
                  </TableCell>
                  <TableCell>{caCh?.conceitoAluno?.numeroBimestre}</TableCell>
                  <TableCell>
                    {caCh && caCh.conceitoAluno?.conceito
                      ? caCh.conceitoAluno?.conceito.descricao
                      : ""}
                  </TableCell>
                  <TableCell>{caCh?.cargaHoraria}</TableCell>
                </TableRow>
              ))
            : ""}
        </TableBody>
      </Table>
    </div>
  );
}
